import type { ReactNode } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsChevronLeft } from "react-icons/bs";
import ModalDialog, { type ModalDismissReason } from "../../../../../components/common/Modal";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import styles from "./ConnectModalShell.module.scss";

export interface ConnectModalShellProps {
  visible: boolean;
  title?: ReactNode;
  subHeader?: ReactNode;
  children: ReactNode;
  primaryLabel?: string;
  onPrimary?: () => void;
  primaryLoading?: boolean;
  primaryDisabled?: boolean;
  backLabel?: string;
  closeLabel?: string;
  onBack?: () => void;
  bodyClassName?: string;
  headerClassName?: string;
  footerClassName?: string;
  compact?: boolean;
  busy?: boolean;
  onClose: () => void;
  onDismiss: (reason: ModalDismissReason) => void;
}

export const ConnectModalShell = ({
  visible,
  title = "Connect Channels",
  subHeader,
  children,
  primaryLabel,
  onPrimary,
  primaryLoading = false,
  primaryDisabled = false,
  backLabel = "Back",
  closeLabel = "Close",
  onBack,
  bodyClassName = "",
  headerClassName = "",
  footerClassName = "",
  compact = false,
  busy = false,
  onClose,
  onDismiss,
}: ConnectModalShellProps): JSX.Element => (
  <ModalDialog
    visible={visible}
    onRequestClose={onDismiss}
    dialogClassName={`${styles.dialog} ${compact ? styles.compactDialog : ""}`}
    contentClassName={`${styles.content} ${compact ? styles.compactContent : ""}`}
    backdropClassName={styles.backdrop}
    bodyClass={styles.modalBody}
    labelledBy="connection-hub-title"
  >
    <div className={styles.shell}>
      <header className={`${styles.header} ${headerClassName}`}>
        <h2 id="connection-hub-title">{title}</h2>
        <MeritoButton
          type="tertiary"
          onlyIcon
          icon={<AiOutlineClose aria-hidden="true" />}
          ariaLabel="Close connection hub"
          disabled={busy}
          onClick={onClose}
          className={styles.closeButton}
        />
      </header>
      {subHeader ? <div className={styles.subHeader}>{subHeader}</div> : null}
      <main className={`${styles.body} ${bodyClassName}`}>{children}</main>
      <footer className={`${styles.footer} ${footerClassName}`}>
        {onBack ? (
          <MeritoButton
            type="tertiary"
            btnText={backLabel}
            icon={<BsChevronLeft aria-hidden="true" />}
            disabled={busy}
            onClick={onBack}
            extraStyles={{ marginRight: "auto" }}
          />
        ) : null}
        <MeritoButton type="inverse" btnText={closeLabel} disabled={busy} onClick={onClose} isRounded className={styles.secondaryAction} />
        {primaryLabel ? (
          <MeritoButton
            type="primary-1"
            btnText={primaryLabel}
            onClick={onPrimary}
            loading={primaryLoading}
            disabled={primaryDisabled}
            isRounded
            className={styles.primaryAction}
          />
        ) : null}
      </footer>
    </div>
  </ModalDialog>
);

export default ConnectModalShell;
